export default {
  strict: true,
  namespaced: true,
  state: {
    invoice: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'city',
      orderAsc: 0,

      dateFrom: '',
      dateTo: '',
      dueDate: '',
      formLoading: false
    }
  },
  mutations: {
    resetInvoice (state) { state.invoice.list = [] },
    addInvoices (state, value) { state.invoice.list.push(value) },
    setInvoiceMaxList (state, value) { state.invoice.maxList = value },
    setInvoiceCurrentPage (state, value) { state.invoice.currentPage = value },
    setInvoicePerPage (state, value) { state.invoice.perPage = value },
    setInvoiceOrder (state, value) { state.invoice.order = value },
    setInvoiceOrderAsc (state, value) { state.invoice.orderAsc = value },

    setInvoiceDateFrom (state, value) { state.invoice.dateFrom = value},
    setInvoiceDateTo (state, value) { state.invoice.dateTo = value},
    setInvoiceDueDate (state, value) { state.invoice.dueDate = value},
    setInvoiceFormLoading (state, value) { state.invoice.formLoading = value}
  },
  sharedMutations: []
}
      


// WEBPACK FOOTER //
// ./src/store/corporate/invoice.js